
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about-us/family-of-companies",
      function () {
        return require("private-next-pages/about-us/family-of-companies/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about-us/family-of-companies"])
      });
    }
  